import { atom } from "recoil"

export const AtomCurrentFontName = atom({
    key:'ATOMCURFONTNAME',
    default:''
})
  